const status_dialog = {
	description: " Wijzig hier de status van uw machine.",
	status: {
		created_snapshot: "Snapshot toegevoegd aan VPS <strong>{{name}}</strong>.",
		deleted_snapshot: "Snapshot <strong>{{name}}</strong> is succesvol verwijderd.",
		forced_reset: "VPS <strong>{{name}}</strong> wordt gereset.",
		forced_shutdown:
			"VPS <strong>{{name}}</strong> wordt afgesloten, dit kan enkele seconden duren.",
		reboot: "We hebben het OS van VPS <strong>{{name}}</strong> gevraagd om te rebooten.",
		rollback: "Uw VPS is hersteld aan de hand van snapshot <strong>{{name}}</strong>.",
		shutdown:
			"We hebben het OS van VPS <strong>{{name}}</strong> gevraagd om af te sluiten. Houd er rekening mee dat dit een moment kan duren.",
		start: "VPS <strong>{{name}}</strong> wordt gestart, dit kan enkele seconden duren.",
		updated_snapshot: "Snapshot <strong>{{name}}</strong> is succesvol gewijzigd.",
	},
	title: "VPS-status wijzigen",
};

export default status_dialog;
